import { ThemeType } from '@/enums/themeType';
import {
  ThemeActions,
  SetThemePayload,
  SetSettingsPayload,
  SetIsAdminViewPayload,
  SetIsAdminEmbedPayload,
} from './props';
import { Setting } from '@starsoft/common/models';

export function setTheme(theme: ThemeType): SetThemePayload {
  return { type: ThemeActions.Set, payload: theme };
}

export function setSettings(payload: Setting): SetSettingsPayload {
  return {
    type: ThemeActions.Settings,
    payload,
  };
}

export function setIsAdminView(payload: boolean): SetIsAdminViewPayload {
  return { type: ThemeActions.IsAdminView, payload };
}

export function setIsAdminEmbed(payload: boolean): SetIsAdminEmbedPayload {
  return { type: ThemeActions.IsAdminEmbed, payload };
}
